import request from './request.js'

// 发送验证码接口
export const phoneCode = (phone) => {
  return request({
    method: 'post',
    url: `/front/api/biz/login/getPhoneCode/${phone}/1`
  })
}
// 登录接口
export const Login = (data) => {
  return request({
    method: 'post',
    url: '/front/api/biz/login/thirdLogin',
    data
  })
}

// 活动详情接口
export const Activity = () => {
  return request({
    method: 'get',
    url: `/front/api/biz/activity/detail/${process.env.VUE_APP_ACTIVITY_ID}`
  })
}

// 预约活动详情接口
export const yyActivity = () => {
  return request({
    method: 'get',
    url: `/front/api/biz/activity/detail/${process.env.VUE_APP_ACTIVITY_ID2}`
  })
}

// 活动信息
export const activityJoins = () => {
  return request({
    method: 'get',
    url: `/front/api/biz/activity/${process.env.VUE_APP_ACTIVITY_ID}/joins`
  })
}
// 用户信息
export const getApiUserDetail = () => {
  return request({
    method: 'get',
    url: `/front/api/biz/user/getApiUserDetail`
  })
}
// 商品详细信息
export const productDetail = (id) => {
  return request({
    method: 'get',
    url: `/front/api/biz/activity/productDetail/${id}`
  })
}

// 高斯登录接口
export const GsLogin = (data) => {
  return request({
    method: 'post',
    url: '/front/api/biz/login/cosmosLogin',
    data
  })
}

// 下单接口
export const Order = (data) => {
  return request({
    method: 'post',
    url: '/front/api/biz/activity/buyProductCreateOrder',
    data
  })
}
// 发起支付接口
export const Pay = (data) => {
  return request({
    method: 'post',
    url: '/front/api/biz/user/payOrder',
    data
  })
}

// 检查订单状态
export const checkOrder = (data) => {
  return request({
    method: 'post',
    url: '/front/api/biz/activity/isPayLotteryOrder',
    data
  })
}

// 领取立减金接口
export const Ljj = (orderId) => {
  return request({
    method: 'post',
    url: `/front/api/biz/user/receiveCoupon/${orderId}`
  })
}

// 抽奖
export const Lottery = (data) => {
  return request({
    method: 'post',
    url: `/front/api/biz/activity/lottery/${process.env.VUE_APP_ACTIVITY_ID}`,
    data
  })
}

// 创建抽奖订单
export const createLotteryOrder = (data) => {
  return request({
    method: 'post',
    url: `/front/api/biz/activity/createLotteryOrder`,
    data
  })
}

// 提取红包
export const wxCashCoupon = (data) => {
  return request({
    method: 'post',
    url: '/front/api/biz/wxCashCoupon/get',
    data
  })
}
// 我的订单
export const getApiUserOrderPage = (data) => {
  return request({
    method: 'get',
    url: '/front/api/biz/user/getApiUserOrderPage',
    params: data
  })
}

// 我的订单详情
export const getApiUserOrderDetail = (orderId) => {
  return request({
    method: 'get',
    url: `/front/api/biz/user/getApiUserOrderDetail/${orderId}`,
  })
}
// 立即使用  提货
export const useOrderProduct = (data) => {
  return request({
    method: 'post',
    url: '/front/api/biz/user/useOrderProduct',
    data
  })
}
// 提货详情
export const useOrderProductDetail = (orderId) => {
  return request({
    method: 'get',
    url: `/front/api/biz/user/useOrderProductDetail/${orderId}`
  })
}
